import React, { PureComponent, Fragment } from 'react';
import { object, func, number } from 'prop-types';
import cn from 'classnames';
import { FETCH_STORAGE_WITH_ALL_ACTIVITIES } from 'api/storage';
import { Query } from 'react-apollo';
import { StorageDetails, ActivityList } from 'containers';
import { MapComponent, ErrorBoundary, Online } from 'common/components';
import { isDesktop } from 'common/utils';
import { Redirect } from 'react-router-dom';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { base64_decode } from 'util/base64';
import { ROUTE_STORAGE_DETAIL } from 'common/constants';
// import './index.css';

const desktop = isDesktop();
class StorageDetail extends PureComponent {
  static displayName = 'StorageDetail';

  static propTypes = {
    match: object,
    onDelete: func,
    history: object,
    season: number.isRequired,
  };

  state = {
    confirmActive: false,
    selectedCrop: null,
  };

  render() {
    const {
      match: {
        params: { encodedId },
      },
      season,
    } = this.props;
    const id = base64_decode(encodedId);
    const WrapperClasses = cn({
      'field-wrapper__wrapper': true,
      'field-wrapper--mapstatic': true,
      columns: true,
      'is-gapless': true,
      'columns--white': !!id,
    });

    const AsideClasses = cn(
      'field-wrapper__aside',
      'column',
      'is-one-third',
      'is-gapless'
    );
    const sourceName = id.split(':')[1];

    return (
      <ErrorBoundary>
        <Query
          query={FETCH_STORAGE_WITH_ALL_ACTIVITIES}
          fetchPolicy="cache-and-network"
          variables={{ id, sourceName, season }}
        >
          {({ loading, error, data }) => {
            // Error can sometimes be set even if we have data.
            // This has been seen for example when loading data from cache
            // (offline) and there's a schema mismatch warning.
            if (loading || (error && data == null)) return null; // handle side effects here in the future.
            const { getStorage, getAllActivities } = data;

            if (getStorage === null) return <Redirect to="/error" />;

            // change activityType to 'STORAGE' and mapping data for `displayAlternateStorageCard`
            const activities =
              getAllActivities &&
              getAllActivities.map(activity => ({
                ...activity,
                activityType: 'STORAGE',
                source: activity.source || {},
                destinations: activity.destinations ||
                  activity.harvesting || [activity.destination],
              }));

            return (
              <Fragment>
                <div className={WrapperClasses}>
                  {this._getStorageMapFragment(getStorage)}
                  <aside className={AsideClasses}>
                    <StorageDetails storage={getStorage} id={id} />
                    <div className="column__inner">
                      <section>
                        <h3 className="column__title text--header">
                          Storage Activity
                        </h3>
                        <ActivityList
                          id={id}
                          type="storage"
                          activities={activities}
                          displayAlternateStorageCard
                          field={true}
                        />
                      </section>
                    </div>
                  </aside>
                </div>
              </Fragment>
            );
          }}
        </Query>
      </ErrorBoundary>
    );
  }

  _getStorageMapFragment(storage) {
    return (
      !!storage &&
      (desktop ? (
        this._getMapComponent(storage)
      ) : (
        <Online>{this._getMapComponent(storage)}</Online>
      ))
    );
  }

  _getMapComponent = storage => (
    <MapComponent
      storages={[storage]}
      showStorages
      showStorageMarkers
      useMaxZoomService
      ignoreMapUpdate
      defaultZoom={18}
      gestureHandling="greedy"
    />
  );
}

const mapState = ({ settings }) => ({ season: settings.season });

const mapDispatch = dispatch => ({
  goToRoute: id => dispatch(push(`${ROUTE_STORAGE_DETAIL}/${id}`)),
});

export default connect(
  mapState,
  mapDispatch
)(StorageDetail);



// WEBPACK FOOTER //
// ./src/pages/Storage/Detail/index.js